import React from 'react';
import style from './MaintenancePage.module.css';
import useApplicationSettings from '../../Store/ApplicationSettings';
import { useEffect } from 'react';
const MaintenancePage = () => {
     const setShowMenubar = useApplicationSettings((state) => state.setShowMenubar);
    useEffect(() => {
        // Скрываем меню при монтировании компонента
        setShowMenubar(false);

        // Восстанавливаем меню при размонтировании
        return () => {
            setShowMenubar(true);
        };
    }, []);
    return (
        <div className={style['maintenance-container']}>
            <div className={style['maintenance-content']}>
                <div className={style['maintenance-icon']}>🛠️</div>
                <h1 className={style['maintenance-title']}>Технические работы</h1>
                <p className={style['maintenance-text']}>
                    В данный момент ведутся технические работы.
                    Пожалуйста, попробуй зайти немного позже.
                </p>
            </div>
            <div className={style['maintenance-button']}>
                <a href="https://t.me/+nOzvuH-pSRIzMzM6" className={style['maintenance-button-button']}>
                    Игровой чат
                </a>
            </div>
        </div>
    );
};

export default MaintenancePage;